import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const ChevronLeftRoundedIcon: React.FC<SvgIconProps> = ({sx, fontSize}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.WHITE,
      ...sx,
    }}
    fontSize={fontSize}
  >
    <path 
      d="M14.71 6.71a.996.996 0 0 0-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
)
